<template>
    <v-card
        flat
        tile
        :class="itemLeftBorderColor + selectedClass"
    >
        <v-toolbar
            flat
            class="ticket-card-header px-3"
        >
            <div class="checkbox-container">
                <slot name="selectCheckbox" />
                <slot name="clipboardCheckbox" />
            </div>
            <div class="ticket-card-ticket-revision">
                <router-link
                    :to="ticketDetailsLink(item.tid)"
                >
                    {{ item.ticketRevision }}
                </router-link>                
            </div>
            <v-spacer />
            <router-link
                :to="ticketDetailsLink(item.tid)"
            >
                <v-chip
                    small
                    :color="statusChipColor"
                    outlined
                    :class="statusChipClass"
                >
                    {{ statusText }}
                </v-chip>
                <v-icon class="mr-2">
                    chevron_right
                </v-icon>
            </router-link>
        </v-toolbar>
        <div class="px-3">
            <!-- center -->
            <div class="ticket-card-info">
                {{ item.center || ' ' }}
            </div>
            <!-- due -->
            <div class="ticket-card-info">
                {{ dueDateText || ' ' }}
            </div>
            <!-- priority -->
            <div class="ticket-card-info">
                <v-icon 
                    small
                    :color="priorityIconColor"
                >
                    {{ priorityIcon }}
                </v-icon> {{ item.priority || ' ' }}
            </div>
            <!-- type -->
            <div class="ticket-card-info">
                {{ item.type || ' ' }}
            </div>
            <!-- CATEGORY -->
            <div
                v-if="item.category"
                class="ticket-card-info"
            >
                {{ item.category || ' ' }}
            </div>
        </div>
        <table class="px-3">
            <tr>
                <td>Member Code:</td>
                <td>{{ item.TR_member_code }}</td>
            </tr>
            <tr v-if="useInsightLogixRisk">
                <td>Risk:</td>
                <td>{{ riskScoreText(item.TR_insight_risk_score) }}</td>
            </tr>
            <tr>
                <td>Work Type:</td>
                <td>{{ item.work_type }}</td>
            </tr>
            <tr>
                <td>Locator:</td>
                <td>{{ item.TR_locator_account || 'Un-Assigned' }}</td>
            </tr>
            <tr>
                <td>Address:</td>
                <td>{{ formatAddress(item.address, item.street, item.place, item.state, item.cross1, item.cross2) }}</td>
            </tr>
            <tr>
                <td>Due Date:</td>
                <td>{{ formatDate(item.duedate) }}</td>
            </tr>
            <tr>
                <td>Work Date:</td>
                <td>{{ formatDate(item.work_date) }}</td>
            </tr>
            <tr v-if="item.work_end_date && item.work_end_date.length">
                <td>Work Ends : </td>
                <td><b>{{ formateDate(item.work_end_date) }}</b></td>
            </tr>
        </table>
    </v-card>    
</template>
<script>
import { hasPermission } from '@/utils/permissions';
import { riskScoreToText } from '@/utils/ticketRisk.js';

export default {
    props: {
        item: {
            type: Object,
            default: () => {},
        },
        statusText: {
            type: String,
            required: true,
        },
        statusChipColor: {
            type: String,
            required: true,
        },
        statusChipClass: {
            type: String,
            required: true,
        },
        dueDateText: {
            type: String,
            default: '',
        },
        itemLeftBorderColor: {
            type: String,
            default: '',
        },
        priorityIcon: {
            type: String,
            default: '',
        },
        priorityIconColor: {
            type: String,
            default: '',
        },
        isSelected: {
            type: Boolean,
            default: false,
        }
    },
    computed: {        
        selectedClass() {
            return this.isSelected ? ' selected' : '';
        },
        useInsightLogixRisk() {
            return hasPermission('USE_INSIGHT_LOGIX_RISK');
        },
    },
    methods: {
        riskScoreText(risk) {
            return riskScoreToText(risk);
        },
        ticketDetailsLink(tid) {
            let link = '/tickets/details?tid=' + tid;
            if(this.$store.getters.forceOffline) {
                link = '/offline' + link;
            }
            return link;
        },
        formatDate(date) {
            date = new Date(date);
            const options = { 
                year: 'numeric', 
                month: '2-digit', 
                day: '2-digit',
                hour: '2-digit', minute: '2-digit'
            };
            return date.toLocaleDateString('en-US', options);
        },
        formatAddress(address, street, place, state, cross1, cross2) {
            // https://norfield.atlassian.net/browse/CWTM-902
            // If address then do "address street, place, state"
            // If address zero length string do "street & cross1, place, state"
            // If address zero length string and cross2 do "street between cross1 & cross2, place, state"
            if(address.length) {
                return address + ' ' + street + ', ' + place + ', ' + state;
            }
            if(cross1?.length) {
                if(cross2?.length) {
                    // If address zero length string and cross2 do "street between cross1 & cross2, place, state"
                    return `${street} between ${cross1} & ${cross2}, ${place}, ${state}`;
                } else {
                    // If address zero length string do "street & cross1, place, state"
                    return `${street} & ${cross1}, ${place}, ${state}`;
                }
            } else {
                return street + ', ' + place + ', ' + state;
            }
        },
    }
};
</script>
<style>
#ticket-cards .v-card {
    padding-bottom: 16px;
}
#ticket-cards .v-card.selected {
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #F26227;
}
#ticket-cards .checkbox-container .v-input--selection-controls {
    margin-top: 0 !important;
}
#ticket-cards .ticket-card-header {
    background-color: var(--ll-surface-subtle);
}
#ticket-cards .ticket-card-header a {
    text-decoration: none;
}
#ticket-cards .ticket-card-ticket-revision a {
    color: #1976D2;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
}
#ticket-cards .ticket-card-header a .v-chip{
    cursor: pointer;
}
#ticket-cards .ticket-card-info {
    border-radius: 4px;
    border: 1px solid var(--ll-border-subtle);
    height: 28px;
    display: inline-block;
    min-width: 40px;
    margin-top: 16px;
    margin-bottom: 16px;
    margin-right: 8px;
    padding: 4px 8px;
    color: var(--ll-text-primary);
    font-size: 12px;
    background: var(--ll-surface);
}
#ticket-cards table {
    font-size: 12px;
    width: 100%;
}
#ticket-cards table tr td:first-child {
    width: 82px;
}
#ticket-cards table tr td:nth-child(2) {
    font-weight: 500;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: 0;
}
#ticket-cards .status-open-chip,
#ticket-cards .status-closed-chip {
    margin-right: 10px;
}
</style>
